import { render, staticRenderFns } from "./EditRiskProfile.vue?vue&type=template&id=d86a54b8&scoped=true"
import script from "./EditRiskProfile.vue?vue&type=script&lang=js"
export * from "./EditRiskProfile.vue?vue&type=script&lang=js"
import style0 from "./EditRiskProfile.vue?vue&type=style&index=0&id=d86a54b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86a54b8",
  null
  
)

export default component.exports